/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGenerateSocialVersionContentMutationRequest, ContentAiGenerateSocialVersionContentMutationResponse, ContentAiGenerateSocialVersionContentPathParams, ContentAiGenerateSocialVersionContent401, ContentAiGenerateSocialVersionContent403 } from "../models/ContentAiGenerateSocialVersionContent";

export function getContentAiGenerateSocialVersionContentUrl(id: ContentAiGenerateSocialVersionContentPathParams["id"], platform: ContentAiGenerateSocialVersionContentPathParams["platform"]) {
  const res = { method: 'PUT', url: `/content-ai/v1/contents/${id}/social-version/${platform}/generate` as const }
  return res
}

/**
 * @summary Generate adapted version of the content for the target platform
 * {@link /content-ai/v1/contents/:id/social-version/:platform/generate}
 */
export async function contentAiGenerateSocialVersionContent(id: ContentAiGenerateSocialVersionContentPathParams["id"], platform: ContentAiGenerateSocialVersionContentPathParams["platform"], data: ContentAiGenerateSocialVersionContentMutationRequest, config: Partial<RequestConfig<ContentAiGenerateSocialVersionContentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ContentAiGenerateSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiGenerateSocialVersionContent401 | ContentAiGenerateSocialVersionContent403>, ContentAiGenerateSocialVersionContentMutationRequest>({ method : "PUT", url : getContentAiGenerateSocialVersionContentUrl(id, platform).url.toString(), data : requestData, ... requestConfig })
  return res.data
}